
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, numeric, double } from 'vee-validate/dist/rules';

extend('required', required);
extend('numeric', numeric);
extend('double', double);

extend('numeric_decimal', {
  validate: (value) => {
    return /^(\d+(\.\d{1,2})?)?$/.test(value); // Allows integers and decimals up to 2 places
  },
  message: 'The field must be a valid number.'
});

extend('price_Validation', {
  validate: (value) => {
    const isValidFormat = /^\d+(\.\d{1,2})?$/.test(value); // Whole number OR decimal up to 2 places
    const numericValue = parseFloat(value);
    const isNonNegative = !isNaN(numericValue) && numericValue >= 0;
    return isValidFormat && isNonNegative;
  },
  message: 'The field must be a valid number and at least 0.'
});


// ✅ Custom rule to allow only letters, numbers, and spaces
extend("alphanumeric_spaces", {
  validate: (value) => /^[A-Za-z0-9 ]+$/.test(value),
  message: "The value must contain only letters, numbers, and spaces.",
});

// Define and register the custom `min_value` rule
extend('min_value', {
  validate(value, { min }) {
    return Number(value) >= min;
  },
  params: ['min'],
  message: 'The {_field_} must be at least {min}.'
});

// Define and register the custom `max_value` rule
extend('max_value', {
  validate(value, { max }) {
    return Number(value) <= max;
  },
  params: ['max'],
  message: 'The {_field_} must be a maximum of {max}.'
});

extend('min', {
  validate(value, { min }) {
    return value.length >= min;
  },
  params: ['min'],
  message: 'The {_field_} must be at least {min} character(s).'
});

// Define and register the custom `max_value` rule
extend('max', {
  validate(value, { max }) {
    return value.length <= max;
  },
  params: ['max'],
  message: 'The {_field_} must be a maximum of {max} character(s).'
});

extend('no_spaces', {
  validate: (value) => !/\s/.test(value),
  message: '{_field_} cannot contain spaces.',
});